import { ButtonProps } from "@mui/material/Button/Button"
import React from "react"
import { StyledButton } from "./styled"

export interface IButtonProps extends ButtonProps {
  label: string,
  height?: number
}

export const Button = ({ label, ...props }: IButtonProps) => {
  return <StyledButton
    color={"secondary"}
    {...props}
    disableRipple
    title={props.title || label}>
    {label}
  </StyledButton>
}
